import { LAYOUT_CONSTANTS } from "@src/constants";
import { styled } from "@uhg-abyss/web/tools/styled";
import { Button } from "@uhg-abyss/web/ui/Button";
import { ModalDialog } from "@uhg-abyss/web/ui/ModalDialog";
import { Text } from "@uhg-abyss/web/ui/Text";

const LocalCenterProviderUnavailableActionRow = styled("div", {
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
  flexWrap: "wrap",
  width: "100%",
});

const LOCAL_CENTER_PROVIDER_UNAVAILABLE_MESSAGE = `The provider you selected is not available based on the information you provided. To find an available provider, click "See other providers".`;

interface LocalCenterProviderUnavailableModalProps {
  isOpen: boolean;
  onSeeOtherProviders: () => void;
}

export const LocalCenterProviderUnavailableModal = ({
  isOpen,
  onSeeOtherProviders,
}: LocalCenterProviderUnavailableModalProps) => {
  return (
    <ModalDialog
      isOpen={isOpen}
      closeOnClickOutside={false}
      hideClose={true}
      size={LAYOUT_CONSTANTS.modalDialogWidth}
      header="Provider not available"
      data-testid="test-id-get-started-local-center-provider-unavailable-modal"
      data-id="obc-get-started-local-center-provider-unavailable-modal"
      data-obc-label="Get Started Local Center Provider Unavailable Modal"
      footer={
        <LocalCenterProviderUnavailableActionRow>
          <Button
            data-testid="test-id-get-started-see-other-providers-button"
            id="obc-get-started-local-center-provider-unavailable-see-other-providers-btn"
            data-id="obc-get-started-local-center-provider-unavailable-see-other-providers-btn"
            data-obc-label="Get Started Local Center Provider Unavailable See Other Providers Button"
            onClick={onSeeOtherProviders}
          >
            See other providers
          </Button>
        </LocalCenterProviderUnavailableActionRow>
      }
    >
      <Text data-testid="test-id-get-started-local-center-provider-unavailable-message">
        {LOCAL_CENTER_PROVIDER_UNAVAILABLE_MESSAGE}
      </Text>
    </ModalDialog>
  );
};
